import { ChangeDetectorRef, Component, EventEmitter, HostListener, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { BsDatepickerConfig, BsDatepickerDirective, BsLocaleService } from 'ngx-bootstrap/datepicker';
import { dateFidelity, dateStatusPayment, fidelityStatus, statusDepositWarrantys, statusPayment, statusTransaction, transactionTypesDepositWarratys, typePayment } from './selectables';
import { RestService } from '../rest.service';
import * as moment from 'moment';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'usb-filter-mannagement',
  templateUrl: './filter-mannagement.component.html',
  styleUrls: ['./filter-mannagement.component.scss']
})
export class FilterMannagementComponent implements OnInit, OnChanges {
  @ViewChild('startDateDp', { static: false }) startDateDp?: BsDatepickerDirective;
  @ViewChild('endDateDp', { static: false }) endDateDp?: BsDatepickerDirective;

  @Input() mannamegentOption: string = '';
  @Input() categories: any[] = [];
  @Input() modelMannagementOptionLength: number = 0;
  @Input() clientSetting: any;


  @Output() filter = new EventEmitter<any>();
  @Output() filterReset = new EventEmitter<any>();

  dpConfig: Partial<BsDatepickerConfig> = new BsDatepickerConfig();
  rangeConfig = {
  isAnimated: true,
  adaptivePosition: true,
  dateInputFormat: 'DD/MM/YYYY',
  showWeekNumbers: false,
};

  formFilter: FormGroup;

  minDate: Date;
  maxDateArrival: Date;
  filterFidelitys: any;
  currentPage: number = 1;
  lastPage: number;
  currentDay: string;
  previousDay: string;
  dateSelected: boolean = false;

  statusList:any;

  dateActionFidelity: any[] = dateFidelity;
  fidelityStatus: any[] = fidelityStatus;

  statusDepositWarrantys: any[] = statusDepositWarrantys;

  statusTransaction: any[] = statusTransaction;

  dateStatusPayment: any[] = dateStatusPayment;
  typePayment: any[] = typePayment;
  statusPayment: any[] = statusPayment;
  transactionTypesDepositWarratys: any[] = transactionTypesDepositWarratys;
  transactionTypes: any[] = [];
  agencies: any[] = [];
  backgroundSelect: any;
  placeholderDateForm: string;
  valueChangeForm: boolean = false;
  styleSidebar: any;
  buttonColorActive: any;
  buttonTextActive: any;
  @HostListener('window:scroll')
  onScrollEvent() {
    this.startDateDp?.hide();
    this.endDateDp?.hide();
  }

  constructor(

              private formBuilder: FormBuilder,
              private localeService: BsLocaleService,
              private restService:RestService,
              private cdr: ChangeDetectorRef

            ) {
              this.formFilter = this.formBuilder.group({});
              this.dpConfig.dateInputFormat = 'DD/MM/YYYY';
              this.dpConfig.showWeekNumbers = true;

            }


  ngOnChanges(changes: SimpleChanges): void {
    if(changes['modelMannagementOptionLength']) {
      this.modelMannagementOptionLength = changes['modelMannagementOptionLength'].currentValue;
    }
    const currentDate = new Date()
    this.placeholderDateForm = moment(currentDate).format('DD/MM/YYYY');
    this.formFilter = this.formBuilder.group({});
    this.initFilter();
  }


  ngOnInit(): void {
    this.styleSidebar = JSON.parse(this.clientSetting.clients_setting_app_booking?.bookingFlow_sidebar);
    this.backgroundSelect = JSON.parse(this.clientSetting?.clients_setting_app_booking?.bookingFlow_body).card_background_price;
    this.buttonColorActive = this.styleSidebar?.background_color_header;
    this.buttonTextActive = this.styleSidebar?.color;
    this.initFilter();
    this.localeService.use('es');

    if(this.mannamegentOption === 'transactions' || this.mannamegentOption === 'depositWarranty' || this.mannamegentOption === 'wallet') {
      this.getTransactionType();
    }
    if(this.mannamegentOption === 'payments') {
      this.getAgencyAll();
    }

  }

  /**
 * Método para inicializar el filtro según la opción seleccionada.
 *
 * Este método inicializa el formulario de filtro correspondiente según el valor de la variable
 * `mannamegentOption`. Los valores posibles de `mannamegentOption` determinan qué formulario de filtro
 * se debe usar. Además, se ejecuta la detección de cambios en la vista después de inicializar el filtro.
 *
 * @switch-> Determina qué formulario de filtro se debe inicializar según el valor de `mannamegentOption`.
 * @cdr-> Detecta los cambios en la vista después de inicializar el filtro.
 */
initFilter(): void {


  const itinerariesFilter = this.mannamegentOption.split('?', 1)[0] ? this.mannamegentOption.split('?', 1)[0] : null;

  if(itinerariesFilter && itinerariesFilter === 'itineraries') {
     this.mannamegentOption = itinerariesFilter;
  }

    switch (this.mannamegentOption) {
      case 'fidelity':
        this.fidelityForm();
        break;
      case 'depositWarranty':
        this.depositWarrantyForm();
        break;
      case 'transactions':
        this.transactionForm();
        break;
      case 'wallet':
        this.walletForm();
        break;
      case 'payments':
        this.paymentForm();
        break;
      case 'clients':
        this.clientForm();
        break;
      case 'itineraries':
        this.getItineraryStatus();
        this.itinerariesForm();
        break;
      case 'flyItineraries':
        this.flyForm();
        break;
      case 'request-receipt':
        this.billingReceiptForm();
        break;
      case 'request-billed':
        this.billingRequestForm();
        break;

  }

  // this.cdr.detectChanges();
}

/**
* Método para inicializar el filtro de fidelidad (blickoins).
*
* Este método configura el formulario de filtro para el tipo "fidelity", que incluye campos
* para filtrar por fecha de acreditación, fecha de pago, estado e ID de itinerario.
*/
fidelityForm(): void {
  this.formFilter = this.formBuilder.group({
    dateAccreditation: new FormControl(null),
    datePayment: new FormControl(null),
    status: new FormControl(null),
    itinerary_id: new FormControl(null)
  });
};

/**
* Método para inicializar el filtro de garantía de depósito.
*
* Este método configura el formulario de filtro para el tipo "depositWarranty", con campos
* que permiten filtrar por fecha de actualización, fecha de vencimiento, tipo de transacción,
* estado de la transacción y referencia.
*/
depositWarrantyForm(): void {
  this.formFilter = this.formBuilder.group({
    dateUpdate: new FormControl(null),
    dateTo: new FormControl(null),
    transaction_type_id: new FormControl(null),
    status_id: new FormControl(null),
    reference_id: new FormControl(null)
  });
};

flyForm(): void {
  this.formFilter = this.formBuilder.group({
    dateUpdate: new FormControl(null),
    selectDate: new FormControl('In'),
    flyNumberIn: new FormControl(null),
    flyNumberOut: new FormControl(null),
  });
};

billingReceiptForm(): void {
  this.formFilter = this.formBuilder.group({
    dateAccreditation: new FormControl(null),
    // datePayment: new FormControl(null),
    // status: new FormControl(null),
    itinerary_id: new FormControl(null)
  });
}

billingRequestForm(): void {
  this.formFilter = this.formBuilder.group({
    dateAccreditation: new FormControl(null),
    datePayment: new FormControl(null),
    status: new FormControl(null),
    itinerary_id: new FormControl(null)
  });
}

/**
* Método para inicializar el filtro de transacciones.
*
* Este método configura el formulario de filtro para el tipo "transactions", permitiendo filtrar
* por fecha de inicio, fecha de fin, estado y referencia de la transacción.
*/
transactionForm(): void {
  this.formFilter = this.formBuilder.group({
    date: new FormControl(null),
    transaction_type_id: new FormControl(null),
    status_id: new FormControl(null),
    reference_id: new FormControl(null)
  })
}

/**
* Método para inicializar el filtro de "MI BILLETERA".
*
* Igual que transactionForm() (misma fuente de datos, transactionMaster) pero con rango de
* fechas (desde/hasta) en vez de una única fecha, para acercarse al filtro de la referencia
* de diseño ("Fecha desde" / "Fecha hasta").
*/
walletForm(): void {
  this.formFilter = this.formBuilder.group({
    dateFrom: new FormControl(null),
    dateTo: new FormControl(null),
    transaction_type_id: new FormControl(null),
    status_id: new FormControl(null)
  });
}

/**
* Método para inicializar el filtro de pagos.
*
* Este método configura el formulario de filtro para el tipo "payments", con campos para filtrar
* por fechas, ID de pago, métodos de pago y estado de pago.
*/
paymentForm(): void {
  console.log('estoy acá')
  this.formFilter = this.formBuilder.group({
    date: new FormControl(null),
    itinerary_id: new FormControl(null),
    agency_id: new FormControl(null),
    agent_id: new FormControl(null),
  });
  console.log(this.formFilter)
};

/**
* Método para inicializar el filtro de clientes.
*
* Este método configura el formulario de filtro para el tipo "clients", permitiendo filtrar por nombre,
* correo electrónico, número de documento, fecha de nacimiento y género del cliente.
*/
clientForm(): void {
  this.formFilter = this.formBuilder.group({
    name: new FormControl(null),
    email: new FormControl(null),
    document_number: new FormControl(null),
    birth_date: new FormControl(null),
    gender: new FormControl(null),
  });
};

/**
* Método para inicializar el filtro de itinerarios.
*
* Este método configura el formulario de filtro para el tipo "itineraries", con campos para filtrar
* por tipo de operación, productos, fechas de creación, inicio, fin y expiración, así como el nombre y
* correo electrónico del cliente.
*/
itinerariesForm(): void {
  this.formFilter = this.formBuilder.group({
    status_id: new FormControl(null),
    idReservation: new FormControl(null),
    // created_at: new FormControl(null),
    dateRange: new FormControl(null),
    // expirationDate: new FormControl(null),
    nameClient: new FormControl(null),
    emailClient: new FormControl(null),
    itinerary_id: new FormControl(null),
    seller: new FormControl(null),
  })
};

/**
* Método para obtener el estado de los itinerarios desde el backend.
*
* Este método realiza una solicitud GET al backend para obtener los estados de los itinerarios
* y almacenarlos en la variable `statusList`.
*/
getItineraryStatus(){

  this.restService.doGet('app', 'itineraries/status').subscribe(
    (response:any) => {
      this.statusList = response.data;

    },
    error =>{
      console.log(error);
    }
  )
};

/**
* Método para emitir el filtro actual.
*
* Este método emite el formulario de filtro actual a través del evento `filter`.
*/
_filter() {
  this.filter.emit(this.formFilter);
}

/**
* Método para restablecer el formulario de filtro.
*
* Este método restablece todos los valores del formulario de filtro y emite un evento `filterReset`
* con el valor `'default'`.
*/
reset(): void {
  this.formFilter.reset();
  this.filterReset.emit('default');

  if(this.mannamegentOption === 'flyItineraries') {
    this.formFilter.get('selectDate').setValue('In');
  }
}

getTransactionType(): void {
  this.restService.doGet_('app', 'transactionTypes/list').subscribe({
    next: (res: any) => {
        console.log(res);

        if(this.mannamegentOption === 'depositWarranty') {
          this.transactionTypes = res.filter(c => c.id === 3 || c.id === 7);
        } else {
          this.transactionTypes = res;
        }
    },
    error: (error: HttpErrorResponse) => {
      console.log(error)
    }
  })
}

getAgencyAll(): void {
  this.restService.doGet_('app', 'allAgencies').subscribe({
    next: (res: any) => {
      console.log(res);
      if(res && res.data && res.data.length > 0) {
        this.agencies = res.data;
      } else {
        this.agencies = [];
      }
    },
    error: (error: HttpErrorResponse) => {
      console.log(error);
    }
  })
}

/**
 * Se genero esta validación para evitar el ingreso de números en el input.
 * @param value // Obtenemos el ariaLabel del input actual.
 */
validateText(value:any){
  // console.log('value', value);
  const nameControl = value.target.ariaLabel;

  const control = this.formFilter.get(`${nameControl}`);
  console.log(control);

  const valueControl = control.value ?? '';

   control.setValue(
    valueControl.replace(/[^a-zA-ZáéíóúÁÉÍÓÚñÑ\s]/g, ''),
    { emitEvent: false }
  );
}

}
